export default {
        title: 'Feature Value Definition',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
                name: 'Feature Value Name',
		unit: 'Unit',
		nickname: 'English Name',
		placeholder: {
                        name: 'Please enter feature value name',
			unit: 'Please enter unit',
			nickname: 'Please enter English name'
		}
	},
	table: {
		id: 'ID',
                name: 'Feature Value Name',
                unit: 'Feature Value Unit',
		nickname: 'English Name',
		dimension: 'Data Dimension',
		remark: 'Remark',
		sort: 'Sort'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	widgetForm: {
                name: 'Feature Value Name',
		unit: 'Unit',
		nickname: 'English Name',
		dimension: 'Data Dimension',
		sort: 'Sort',
		remark: 'Remark',
		gridLayout: 'Grid Layout',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
                        name: 'Please enter feature value name',
			unit: 'Please enter unit',
			nickname: 'Please enter English name'
		}
	},
	dimension: {
		value1: 'Label 1',
		value2: 'Label 2',
		value3: 'Label 3'
	}
}
